module.exports = __webpack_public_path__ + "ad2232687eb426a443af3de7586286bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-320.jpg
// module id = 201
// module chunks = 0